import { useEffect, useState } from "react";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";

// We're not using plurals in this app, but LinguiJS will
// spit out console errors if we don't configure them.
import { en as enPlurals, ne as nePlurals } 
  from "make-plural/plurals";

// Import our translation messages.
import { messages as enMessages } from "./locales/en-US/messages";
import { messages as neMessages } from "./locales/ne-NP/messages";
import React from "react";

const localeConfig = {
  "en-US": { messages: enMessages, plurals: enPlurals },
  "ne-NP": { messages: neMessages, plurals: nePlurals },
};

// const defaultLocale = "ne-NP";
const defaultLocale = "en-US";

// Loads plurals and translation messages for the given
// locale and sets this locale as the active one.
function loadLocale(locale) {
  const { plurals, messages } = localeConfig[locale];

  i18n.loadLocaleData(locale, { plurals });
  i18n.load(locale, messages);
  i18n.activate(locale);
}

// Load our default locale initially.
loadLocale(defaultLocale);
// Our wrapper component. We use a React render prop to
// expose the setLocale() function.
function I18n({ render }) {
  const [locale, setLocale] = useState(defaultLocale);

  useEffect(() => loadLocale(locale), [locale]);

  // LinguiJS's I18nProvider component wraps our app component
  // tree, ensuring that all of our nested components use the 
  // same i18n instance and are aware of the active locale.
  return (
    <I18nProvider i18n={i18n}>
       {render(setLocale)}
    </I18nProvider>
  );
}

export default I18n;